var map = {
	"./bangkok.jpg": 4621,
	"./barcelona.jpg": 4945,
	"./berlin.jpg": 2916,
	"./cancun.jpg": 2148,
	"./doha.jpg": 9002,
	"./dubai.jpg": 993,
	"./honolulu.jpg": 6690,
	"./istanbul.jpg": 5842,
	"./lisbon.jpg": 7005,
	"./london.jpg": 1274,
	"./losangeles.jpg": 7581,
	"./madrid.jpg": 275,
	"./miami.jpg": 7635,
	"./newyork.jpg": 3205,
	"./paris.jpg": 4539,
	"./rome.jpg": 1527,
	"./sanjuan.jpg": 5146,
	"./seoul.jpg": 6026,
	"./seville.jpg": 2914,
	"./singapore.jpg": 9236,
	"./tokyo.jpg": 836,
	"./toronto.jpg": 4281,
	"./vancouver.jpg": 9287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7935;